/* eslint-disable react/jsx-pascal-case */
import React from "react";

import {ConnectedReportingBlock} from "../../atoms/reporting-block";
import {ReportingRow} from "../../atoms/admin-reporting/atoms/reporting-row";
import {
  analyticsResidentsAdmissionSection,
  analyticsResidentsArbitrationSection,
  analyticsResidentsMedicaidSection,
  analyticsResidentsMedicareSection,
  analyticsStaffAdmissionSection,
  reportsSlideAnswersAdmissionSection,
  reportsSlideAnswersAdvancedDirectiveSection,
  reportsSlideAnswersFuneralSection,
  reportsSlideAnswersLaundrySection,
  reportsSlideAnswersMedicaidSection,
  reportsSlideAnswersMedicareSection,
  reportsSlideAnswersSurrogateSection,
  reportsSlideAnswersTrustFundSection,
  reportsSlideAnswersVaccinesSection,
  reportsStaffAdmissionSection,
} from "./constants";
import {
  ADMISSIONS_COMPLETION_ON_TIME_CHART_ID,
  ADMISSIONS_COMPLETION_OVERALL_CHART_ID,
  ADMISSIONS_TIME_BY_STAGE_CHART_ID,
  ADMISSIONS_TOTAL_CHART_ID,
  ADMISSIONS_TOTAL_RESIDENTS_CHART_ID,
  AnalyticsAdmissionsCompletionOnTime,
  AnalyticsAdmissionsCompletionOverall,
  AnalyticsAdmissionsFacilityCompletionRate,
  AnalyticsAdmissionsStaffCompletionRate,
  AnalyticsAdmissionsTotal,
  AnalyticsAdmissionsTotalResidents,
  AnalyticsArbitrationAgreementRate,
  AnalyticsFlagsAge,
  AnalyticsFlagsBySlidePie,
  AnalyticsManagedMedicaidByFacility,
  AnalyticsManagedMedicaidTimeSeries,
  AnalyticsPayerSourceAge65_75,
  AnalyticsPayerSourceAge65_75ByCountry,
  AnalyticsPayerSourceAge75_85,
  AnalyticsPayerSourceAge75_85ByCountry,
  AnalyticsPayerSourceAge85,
  AnalyticsPayerSourceAge85ByCountry,
  AnalyticsReAdmissionRateByFacility,
  AnalyticsReAdmissionRateTimeSeries,
  AnalyticsRepresentativeRateByFacility,
  AnalyticsRepresentativeRateTimeSeries,
  AnalyticsTimeByStage,
  AnalyticsWithoutMedicalSupplementByFacility,
  AnalyticsWithoutMedicalSupplementTimeSeries,
  ARBITRATION_AGREEMENT_RATE_CHART_ID,
  FACILITY_COMPLETION_RATE_CHART_ID,
  FLAGS_AGE_CHART_ID,
  FLAGS_BY_SLIDE_CHART_ID,
  MANAGED_MEDICAID_BY_FACILITY_CHART_ID,
  MANAGED_MEDICAID_CHART_ID,
  PAYER_SOURCE_65_75_BY_COUNTRY_CHART_ID,
  PAYER_SOURCE_65_75_CHART_ID,
  PAYER_SOURCE_75_85_BY_COUNTRY_CHART_ID,
  PAYER_SOURCE_75_85_CHART_ID,
  PAYER_SOURCE_85_BY_COUNTRY_CHART_ID,
  PAYER_SOURCE_85_CHART_ID,
  RE_ADMISSION_RATE_BY_FACILITY_CHART_ID,
  RE_ADMISSION_RATE_CHART_ID,
  REPRESENTATIVE_RATE_BY_FACILITY_CHART_ID,
  REPRESENTATIVE_RATE_CHART_ID,
  STAFF_COMPLETION_RATE_CHART_ID,
  WITHOUT_MEDICARE_SUPPLEMENT_BY_FACILITY_CHART_ID,
  WITHOUT_MEDICARE_SUPPLEMENT_CHART_ID,
} from "./analytics";
import {
  AD_HELP_REPORT_ID,
  AD_PROVIDED_REPORT_ID,
  FACILITY_CHANGES_REPORT_ID,
  FUNERAL_REPORT_ID,
  INCOME_REPORT_ID,
  INFLUENZA_REPORT_ID,
  LAUNDRY_REPORT_ID,
  MEDICAID_REQUEST_REPORT_ID,
  MEDICARE_WAIVER_REPORT_ID,
  PNEUMOCOCCAL_REPORT_ID,
  ReportADHelp,
  ReportExistingADProvided,
  ReportFacilityChanges,
  ReportFuneral,
  ReportInfluenza,
  ReportLaundry,
  ReportMedicaidRequest,
  ReportMedicareWaiver,
  ReportPersonalResourceIncomeAgreement,
  ReportPneumococcal,
  ReportSlideInteractions,
  ReportSNFABNEstimatedCostAdmission,
  ReportStaff,
  ReportSurrogateDecisionMaking,
  ReportSurrogateDecisionMakingHelp,
  ReportTrustFund,
  SLIDE_INTERACTIONS_REPORT_ID,
  SNFABN_COST_ADMISSION_REPORT_ID,
  STAFF_REPORT_ID,
  SURROGATE_HELP_REPORT_ID,
  SURROGATE_REPORT_ID,
  TRUST_FUND_REPORT_ID,
} from "./reports";
import {
  ReportingSectionFrame,
  ReportingSectionRenderer,
} from "./ReportingSectionFrame";

const AnalyticsResidentsAdmissionSectionView: ReportingSectionRenderer = ({
  baseDateRange,
  activeFacilitiesIds,
}) => (
  <ReportingSectionFrame section={analyticsResidentsAdmissionSection}>
    <ConnectedReportingBlock chartId={ADMISSIONS_TOTAL_CHART_ID}>
      {reportingBlockSetters => (
        <AnalyticsAdmissionsTotal
          dateRange={baseDateRange}
          facilities={activeFacilitiesIds}
          reportingBlockSetters={reportingBlockSetters}
        />
      )}
    </ConnectedReportingBlock>
    <ConnectedReportingBlock chartId={ADMISSIONS_TOTAL_RESIDENTS_CHART_ID}>
      {reportingBlockSetters => (
        <AnalyticsAdmissionsTotalResidents
          dateRange={baseDateRange}
          facilities={activeFacilitiesIds}
          reportingBlockSetters={reportingBlockSetters}
        />
      )}
    </ConnectedReportingBlock>
    <ReportingRow>
      <ConnectedReportingBlock half chartId={FACILITY_COMPLETION_RATE_CHART_ID}>
        {reportingBlockSetters => (
          <AnalyticsAdmissionsFacilityCompletionRate
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
      <ConnectedReportingBlock half chartId={STAFF_COMPLETION_RATE_CHART_ID}>
        {reportingBlockSetters => (
          <AnalyticsAdmissionsStaffCompletionRate
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
    <ConnectedReportingBlock chartId={ADMISSIONS_COMPLETION_ON_TIME_CHART_ID}>
      {reportingBlockSetters => (
        <AnalyticsAdmissionsCompletionOnTime
          dateRange={baseDateRange}
          facilities={activeFacilitiesIds}
          reportingBlockSetters={reportingBlockSetters}
        />
      )}
    </ConnectedReportingBlock>
    <ConnectedReportingBlock chartId={ADMISSIONS_COMPLETION_OVERALL_CHART_ID}>
      {reportingBlockSetters => (
        <AnalyticsAdmissionsCompletionOverall
          dateRange={baseDateRange}
          facilities={activeFacilitiesIds}
          reportingBlockSetters={reportingBlockSetters}
        />
      )}
    </ConnectedReportingBlock>
    <ConnectedReportingBlock chartId={FLAGS_BY_SLIDE_CHART_ID}>
      {reportingBlockSetters => (
        <>
          <AnalyticsFlagsBySlidePie
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        </>
      )}
    </ConnectedReportingBlock>
    <ReportingRow>
      <ConnectedReportingBlock half chartId={REPRESENTATIVE_RATE_CHART_ID}>
        {reportingBlockSetters => (
          <AnalyticsRepresentativeRateTimeSeries
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
      <ConnectedReportingBlock
        half
        chartId={REPRESENTATIVE_RATE_BY_FACILITY_CHART_ID}
      >
        {reportingBlockSetters => (
          <AnalyticsRepresentativeRateByFacility
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
    <ReportingRow>
      <ConnectedReportingBlock half chartId={PAYER_SOURCE_65_75_CHART_ID}>
        {reportingBlockSetters => (
          <AnalyticsPayerSourceAge65_75
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
      <ConnectedReportingBlock
        half
        chartId={PAYER_SOURCE_65_75_BY_COUNTRY_CHART_ID}
      >
        {reportingBlockSetters => (
          <AnalyticsPayerSourceAge65_75ByCountry
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
    <ReportingRow>
      <ConnectedReportingBlock half chartId={PAYER_SOURCE_75_85_CHART_ID}>
        {reportingBlockSetters => (
          <AnalyticsPayerSourceAge75_85
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
      <ConnectedReportingBlock
        half
        chartId={PAYER_SOURCE_75_85_BY_COUNTRY_CHART_ID}
      >
        {reportingBlockSetters => (
          <AnalyticsPayerSourceAge75_85ByCountry
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
    <ReportingRow>
      <ConnectedReportingBlock half chartId={PAYER_SOURCE_85_CHART_ID}>
        {reportingBlockSetters => (
          <AnalyticsPayerSourceAge85
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
      <ConnectedReportingBlock
        half
        chartId={PAYER_SOURCE_85_BY_COUNTRY_CHART_ID}
      >
        {reportingBlockSetters => (
          <AnalyticsPayerSourceAge85ByCountry
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
    <ReportingRow>
      <ConnectedReportingBlock half chartId={RE_ADMISSION_RATE_CHART_ID}>
        {reportingBlockSetters => (
          <AnalyticsReAdmissionRateTimeSeries
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
      <ConnectedReportingBlock
        half
        chartId={RE_ADMISSION_RATE_BY_FACILITY_CHART_ID}
      >
        {reportingBlockSetters => (
          <AnalyticsReAdmissionRateByFacility
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
  </ReportingSectionFrame>
);

const AnalyticsResidentsArbitrationSectionView: ReportingSectionRenderer = ({
  baseDateRange,
  activeFacilitiesIds,
}) => (
  <ReportingSectionFrame section={analyticsResidentsArbitrationSection}>
    <ConnectedReportingBlock chartId={ARBITRATION_AGREEMENT_RATE_CHART_ID}>
      {reportingBlockSetters => (
        <AnalyticsArbitrationAgreementRate
          dateRange={baseDateRange}
          facilities={activeFacilitiesIds}
          reportingBlockSetters={reportingBlockSetters}
        />
      )}
    </ConnectedReportingBlock>
  </ReportingSectionFrame>
);

const AnalyticsResidentsMedicaidSectionView: ReportingSectionRenderer = ({
  baseDateRange,
  activeFacilitiesIds,
}) => (
  <ReportingSectionFrame section={analyticsResidentsMedicaidSection}>
    <ReportingRow>
      <ConnectedReportingBlock half chartId={MANAGED_MEDICAID_CHART_ID}>
        {reportingBlockSetters => (
          <AnalyticsManagedMedicaidTimeSeries
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
      <ConnectedReportingBlock
        half
        chartId={MANAGED_MEDICAID_BY_FACILITY_CHART_ID}
      >
        {reportingBlockSetters => (
          <AnalyticsManagedMedicaidByFacility
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
  </ReportingSectionFrame>
);

const AnalyticsResidentsMedicareSectionView: ReportingSectionRenderer = ({
  baseDateRange,
  activeFacilitiesIds,
}) => (
  <ReportingSectionFrame section={analyticsResidentsMedicareSection}>
    <ReportingRow>
      <ConnectedReportingBlock
        half
        chartId={WITHOUT_MEDICARE_SUPPLEMENT_CHART_ID}
      >
        {reportingBlockSetters => (
          <AnalyticsWithoutMedicalSupplementTimeSeries
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
      <ConnectedReportingBlock
        half
        chartId={WITHOUT_MEDICARE_SUPPLEMENT_BY_FACILITY_CHART_ID}
      >
        {reportingBlockSetters => (
          <AnalyticsWithoutMedicalSupplementByFacility
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
  </ReportingSectionFrame>
);

const AnalyticsStaffAdmissionSectionView: ReportingSectionRenderer = ({
  baseDateRange,
  activeFacilitiesIds,
}) => (
  <ReportingSectionFrame section={analyticsStaffAdmissionSection}>
    <ConnectedReportingBlock chartId={FLAGS_AGE_CHART_ID}>
      {reportingBlockSetters => (
        <AnalyticsFlagsAge
          dateRange={baseDateRange}
          facilities={activeFacilitiesIds}
          reportingBlockSetters={reportingBlockSetters}
        />
      )}
    </ConnectedReportingBlock>
    <ConnectedReportingBlock chartId={ADMISSIONS_TIME_BY_STAGE_CHART_ID}>
      {reportingBlockSetters => (
        <AnalyticsTimeByStage
          dateRange={baseDateRange}
          facilities={activeFacilitiesIds}
          reportingBlockSetters={reportingBlockSetters}
        />
      )}
    </ConnectedReportingBlock>
  </ReportingSectionFrame>
);

const ReportsSlideAnswersAdmissionSectionView: ReportingSectionRenderer = ({
  baseDateRange,
  activeFacilitiesIds,
}) => (
  <ReportingSectionFrame section={reportsSlideAnswersAdmissionSection}>
    <ConnectedReportingBlock chartId={SLIDE_INTERACTIONS_REPORT_ID}>
      {reportingBlockSetters => (
        <ReportSlideInteractions
          dateRange={baseDateRange}
          facilities={activeFacilitiesIds}
          reportingBlockSetters={reportingBlockSetters}
        />
      )}
    </ConnectedReportingBlock>
    <ConnectedReportingBlock chartId={STAFF_REPORT_ID}>
      {reportingBlockSetters => (
        <ReportStaff
          dateRange={baseDateRange}
          facilities={activeFacilitiesIds}
          reportingBlockSetters={reportingBlockSetters}
        />
      )}
    </ConnectedReportingBlock>
  </ReportingSectionFrame>
);

const ReportsSlideAnswersTrustFundSectionView: ReportingSectionRenderer = ({
  baseDateRange,
  activeFacilitiesIds,
}) => (
  <ReportingSectionFrame section={reportsSlideAnswersTrustFundSection}>
    <ReportingRow>
      <ConnectedReportingBlock chartId={INCOME_REPORT_ID}>
        {reportingBlockSetters => (
          <ReportPersonalResourceIncomeAgreement
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
      <ConnectedReportingBlock chartId={TRUST_FUND_REPORT_ID}>
        {reportingBlockSetters => (
          <ReportTrustFund
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
  </ReportingSectionFrame>
);

const ReportsSlideAnswersLaundrySectionView: ReportingSectionRenderer = ({
  baseDateRange,
  activeFacilitiesIds,
}) => (
  <ReportingSectionFrame section={reportsSlideAnswersLaundrySection}>
    <ReportingRow>
      <ConnectedReportingBlock chartId={LAUNDRY_REPORT_ID}>
        {reportingBlockSetters => (
          <ReportLaundry
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
  </ReportingSectionFrame>
);

const ReportsSlideAnswersVaccinesSectionView: ReportingSectionRenderer = ({
  baseDateRange,
  activeFacilitiesIds,
}) => (
  <ReportingSectionFrame section={reportsSlideAnswersVaccinesSection}>
    <ReportingRow>
      <ConnectedReportingBlock chartId={PNEUMOCOCCAL_REPORT_ID}>
        {reportingBlockSetters => (
          <ReportPneumococcal
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
      <ConnectedReportingBlock chartId={INFLUENZA_REPORT_ID}>
        {reportingBlockSetters => (
          <ReportInfluenza
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
  </ReportingSectionFrame>
);

const ReportsSlideAnswersSurrogateSectionView: ReportingSectionRenderer = ({
  baseDateRange,
  activeFacilitiesIds,
}) => (
  <ReportingSectionFrame section={reportsSlideAnswersSurrogateSection}>
    <ReportingRow>
      <ConnectedReportingBlock chartId={SURROGATE_REPORT_ID}>
        {reportingBlockSetters => (
          <ReportSurrogateDecisionMaking
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
      <ConnectedReportingBlock chartId={SURROGATE_HELP_REPORT_ID}>
        {reportingBlockSetters => (
          <ReportSurrogateDecisionMakingHelp
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
  </ReportingSectionFrame>
);

const ReportsSlideAnswersAdvancedDirectiveSectionView: ReportingSectionRenderer =
  ({baseDateRange, activeFacilitiesIds}) => (
    <ReportingSectionFrame
      section={reportsSlideAnswersAdvancedDirectiveSection}
    >
      <ReportingRow>
        <ConnectedReportingBlock chartId={AD_PROVIDED_REPORT_ID}>
          {reportingBlockSetters => (
            <ReportExistingADProvided
              dateRange={baseDateRange}
              facilities={activeFacilitiesIds}
              reportingBlockSetters={reportingBlockSetters}
            />
          )}
        </ConnectedReportingBlock>
        <ConnectedReportingBlock chartId={AD_HELP_REPORT_ID}>
          {reportingBlockSetters => (
            <ReportADHelp
              dateRange={baseDateRange}
              facilities={activeFacilitiesIds}
              reportingBlockSetters={reportingBlockSetters}
            />
          )}
        </ConnectedReportingBlock>
      </ReportingRow>
    </ReportingSectionFrame>
  );

const ReportsSlideAnswersFuneralSectionView: ReportingSectionRenderer = ({
  baseDateRange,
  activeFacilitiesIds,
}) => (
  <ReportingSectionFrame section={reportsSlideAnswersFuneralSection}>
    <ReportingRow>
      <ConnectedReportingBlock chartId={FUNERAL_REPORT_ID}>
        {reportingBlockSetters => (
          <ReportFuneral
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
  </ReportingSectionFrame>
);

const ReportsSlideAnswersMedicareSectionView: ReportingSectionRenderer = ({
  baseDateRange,
  activeFacilitiesIds,
}) => (
  <ReportingSectionFrame section={reportsSlideAnswersMedicareSection}>
    <ReportingRow>
      <ConnectedReportingBlock chartId={MEDICARE_WAIVER_REPORT_ID}>
        {reportingBlockSetters => (
          <ReportMedicareWaiver
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
  </ReportingSectionFrame>
);

const ReportsSlideAnswersMedicaidSectionView: ReportingSectionRenderer = ({
  baseDateRange,
  activeFacilitiesIds,
}) => (
  <ReportingSectionFrame section={reportsSlideAnswersMedicaidSection}>
    <ReportingRow>
      <ConnectedReportingBlock chartId={MEDICAID_REQUEST_REPORT_ID}>
        {reportingBlockSetters => (
          <ReportMedicaidRequest
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
  </ReportingSectionFrame>
);

const ReportsStaffAdmissionSectionView: ReportingSectionRenderer = ({
  baseDateRange,
  activeFacilitiesIds,
}) => (
  <ReportingSectionFrame section={reportsStaffAdmissionSection}>
    <ReportingRow>
      <ConnectedReportingBlock chartId={SNFABN_COST_ADMISSION_REPORT_ID}>
        {reportingBlockSetters => (
          <ReportSNFABNEstimatedCostAdmission
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
      <ConnectedReportingBlock chartId={FACILITY_CHANGES_REPORT_ID}>
        {reportingBlockSetters => (
          <ReportFacilityChanges
            dateRange={baseDateRange}
            facilities={activeFacilitiesIds}
            reportingBlockSetters={reportingBlockSetters}
          />
        )}
      </ConnectedReportingBlock>
    </ReportingRow>
  </ReportingSectionFrame>
);

export const otherSectionById: Record<string, ReportingSectionRenderer> = {
  [analyticsResidentsAdmissionSection.id]:
    AnalyticsResidentsAdmissionSectionView,
  [analyticsResidentsArbitrationSection.id]:
    AnalyticsResidentsArbitrationSectionView,
  [analyticsResidentsMedicaidSection.id]: AnalyticsResidentsMedicaidSectionView,
  [analyticsResidentsMedicareSection.id]: AnalyticsResidentsMedicareSectionView,
  [analyticsStaffAdmissionSection.id]: AnalyticsStaffAdmissionSectionView,
  [reportsSlideAnswersAdmissionSection.id]:
    ReportsSlideAnswersAdmissionSectionView,
  [reportsSlideAnswersTrustFundSection.id]:
    ReportsSlideAnswersTrustFundSectionView,
  [reportsSlideAnswersLaundrySection.id]: ReportsSlideAnswersLaundrySectionView,
  [reportsSlideAnswersVaccinesSection.id]:
    ReportsSlideAnswersVaccinesSectionView,
  [reportsSlideAnswersSurrogateSection.id]:
    ReportsSlideAnswersSurrogateSectionView,
  [reportsSlideAnswersAdvancedDirectiveSection.id]:
    ReportsSlideAnswersAdvancedDirectiveSectionView,
  [reportsSlideAnswersFuneralSection.id]: ReportsSlideAnswersFuneralSectionView,
  [reportsSlideAnswersMedicareSection.id]:
    ReportsSlideAnswersMedicareSectionView,
  [reportsSlideAnswersMedicaidSection.id]:
    ReportsSlideAnswersMedicaidSectionView,
  [reportsStaffAdmissionSection.id]: ReportsStaffAdmissionSectionView,
};
